(function() {
    $(document).ready(function(){
        const $slider = $('.featured-slider');

        let slideCount = $slider.find('.post-card').length;

        $slider.on('init', function(event, slick){
            $slider.addClass('ready');
        });

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $slider.find('.slick-cloned').removeClass('slick-current-clone');
            let nextLeft = nextSlide - slideCount;
            let nexRight = nextSlide + slideCount;
            $slider.find(`.slick-cloned[data-slick-index=${ nextLeft }]`).addClass('slick-current-clone');
            $slider.find(`.slick-cloned[data-slick-index=${ nexRight }]`).addClass('slick-current-clone');
        });
        $slider.on('afterChange', function(event, slick, currentSlide){
        });

        $slider.slick({
            infinite: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0',
            variableWidth: true,
            autoplaySpeed: 5000,
            speed: 750,
            cssEase: 'cubic-bezier(.43,.1,.17,1)',
            // cssEase: '',
            dots: true,
            appendDots: '.slider-dots',
            autoplay: true,
            
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        speed: 350,
                    },
                },
            ],
        });

        
        $slider.on('click', '.slick-slide', e => {
            let $slide = $(e.currentTarget);
            if (!$slide.hasClass('slick-active')) {
                e.preventDefault();
                e.stopPropagation();
                let isLast = $slide.next('.slick-slide:not(.slick-clone)').length == 0;
                let isNext = $slide.next('.slick-slide:not(.slick-clone).slick-active').length == 0;
                if (isNext && !isLast) {
                    $slider.slick('slickNext');
                } else {
                    $slider.slick('slickPrev');
                }
            }
        });

    }); 
})();